import { useCallback, useMemo, useRef } from 'react';
import { useThrottleFn } from 'ahooks';
import { isStringEmpty } from '@shared/utils';
import ListItem from './ListItem';
import wsStore from '../store';

function MessageList(props) {
  const store = wsStore.currentStore;
  const { historyData } = store;

  const containerRef = useRef(null);
  const scrollingTimer = useRef(0);

  const items = useMemo(() => {
    const arr = [...props.items];
    return Array.isArray(arr) && arr.length > 0 ? arr.reverse() : [];
  }, [props.items]);

  const fetchMore = useCallback(() => {
    if (!isStringEmpty(store.historyData.npt)) {
      store.fetchChatHistory(historyData.conversation_id);
    }
  }, []);

  const { run: onScroll } = useThrottleFn(
    event => {
      const { offsetHeight, scrollHeight, scrollTop } = event.target;
      if (scrollHeight + scrollTop - offsetHeight <= 100) {
        fetchMore();
      }
    },
    { wait: 500 },
  );

  return (
    <div
      ref={containerRef}
      className={[
        'size-full overflow-y-scroll chat-scrollbar chat-scrollbar-hidden',
        'p-[16px] pr-[10px] pb-[100px]',
        'flex flex-col-reverse items-center',
      ]}
      onScroll={event => {
        const classList = containerRef.current.classList;

        if (classList.contains('chat-scrollbar-hidden')) {
          classList.remove('chat-scrollbar-hidden');
        }

        window.clearTimeout(scrollingTimer.current);
        scrollingTimer.current = setTimeout(() => {
          if (!classList.contains('chat-scrollbar-hidden')) {
            classList.add('chat-scrollbar-hidden');
          }
        }, 300);

        onScroll(event);
      }}
    >
      <ul className="w-full flex flex-col-reverse gap-[24px]">
        {items.map((item, index) => (
          <ListItem key={index} index={index} {...item} />
        ))}
      </ul>
    </div>
  );
}

export default MessageList;
